import "./utilies/keyboard/GlobalKeyGuard";
import React from "react";
import ReactDOM from "react-dom/client";
import system from "./theme";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import ErrorBoundary from "./ErrorBoundary";
import { Toaster } from "./components/ui/toaster";
import { MapObjectsProvider } from "./context/MapObjectsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <ChakraProvider value={system}>
      <MapObjectsProvider>
        <App />
        <Toaster />
      </MapObjectsProvider>
    </ChakraProvider>
  </ErrorBoundary>
);

reportWebVitals();
